<template>
  <div class="crowdfund-sale">
    <div class="crowdfund-sale-main">
      <div class="details-column md-layout-item">
        <detail-row :prop="i18n.sale_project_name()" :value="`${sale.name}`"/>
        <detail-row :prop="i18n.sale_start_time()" :value="`${i18n.d(sale.startTime)}`"/>
        <detail-row :prop="i18n.sale_close_time()" :value="`${i18n.d(sale.endTime)}`"/>
        <detail-row :prop="i18n.sale_base_asset_for_hard_cap()" :value="`${sale.defaultQuoteAsset}`"/>
        <detail-row :prop="i18n.sale_soft_cap()" :value="`${this.roundCurrency(sale.softCap, sale.defaultQuoteAsset)} ${sale.defaultQuoteAsset}`"/>
        <detail-row :prop="i18n.sale_hard_cap()" :value="`${this.roundCurrency(sale.hardCap, sale.defaultQuoteAsset)} ${sale.defaultQuoteAsset}`"/>
        <detail-row :prop="`${i18n.sale_base_asset_hard_cap_to_sell({asset:sale.baseAsset})}`" :value="`${i18n.c(sale.baseHardCap)} ${sale.baseAsset}`"/>
      </div>
    </div>
  </div>
</template>

<script>
  import DetailRow from '@vue/app/common/Detail.Row'
  import CurrencyRound from '@com/mixins/currency.round.mixin'
  import { i18n } from '@js/i18n'
  export default {
    name: 'token-tab',
    mixins: [CurrencyRound],

    components: {
      DetailRow
    },
    props: ['sale'],
    data: _ => ({
      i18n
    }),
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';
</style>



// WEBPACK FOOTER //
// src/vue/app/sales/sale_details/tabs/Sales.SaleTab.vue